import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
// import axios from 'axios'
// import store from './store'
import OwlCarousel from 'vue-owl-carousel'
Vue.component('OwlCarousel', OwlCarousel)
import VueElementLoading from "vue-element-loading";
Vue.component("VueElementLoading", VueElementLoading);
import ServerError from './components/Common/500'
Vue.component('ServerError', ServerError)
Vue.config.productionTip = false

new Vue({
    router,
    // store,
    vuetify,
    render: h => h(App)
}).$mount('#app')